module.exports = __webpack_public_path__ + "static/media/مهرجان الجاز الأسطوري في مونترو.1680583a.jpeg";